'use strict';

const cache = {};

const dates = require('util/date');

const forEach = require('lodash/forEach');
const groupBy = require('lodash/groupBy');

const now = dates.moment();

const ACCESS_TYPES = {
    'A': {
        'type': 'audio',
        'name': 'Audio Described',
        'href': 'audio-described',
    },
    'C': {
        'type': 'captioned',
        'name': 'Captioned',
        'href': 'open-captioning',
    },
    'S': {
        'type': 'auslan',
        'name': 'Signed Performance',
        'href': 'auslan-interpreted',
    },
    'T': {
        'type': 'tactile',
        'name': 'Tactile Tour',
        'href': 'tactile-tour',
    },
    'R': {
        'type': 'relaxed',
        'name': 'Relaxed Performance',
        'href': 'relaxed-performance',
    },
};

const PERF_TYPES = {
    'D': {
        'type': 'D',
    },
    'E': {
        'type': 'E',
    },
    'F': {
        'type': 'F',
    },
    'P': {
        'type': 'P',
    },
    'R': {
        'type': 'R',
    },
};

/**
 * Ported over from Signature Theatre.
 */
module.exports = ['$http', 'appConfig', ($http, appConfig) => {
    let
        firstEventDate = now.clone().startOf('hour'),
        lastEventDate = now.clone(),
        events = {},
        weekDays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

    function getEvents() {
        if ('getEvents' in cache) {
            return cache.getEvents;
        }

        cache.getEvents = $http.get(appConfig.eventFeedURL, { cache: true, withCredentials: true }).then(response => {
            forEach(response.data, item => {
                processEvent(item);
            });
        });

        return cache.getEvents;
    }

    function processEvent(event) {
        let
            date = dates.moment(event.start_date),
            timestamp = dates.moment([date.year(), date.month(), date.date()]).valueOf(),
            performanceStarts = dates.moment(event.start_date);

        event.starts = date;
        event.availability_status = 'WebAvailability' in event.web_contents ? event.web_contents.WebAvailability : null;

        event.perf_types = event.access_type ? event.access_type.split(',') : [];
        event.perf_types = event.perf_types.filter(type => {
            return type in PERF_TYPES;
        }).map(type => {
            return PERF_TYPES[type];
        });

        event.access_types = event.access_type ? event.access_type.split(',') : [];
        event.access_types = event.access_types.filter(type => {
            return type in ACCESS_TYPES;
        }).map(type => {
            return ACCESS_TYPES[type];
        });

        if (performanceStarts.isAfter(lastEventDate)) {
            lastEventDate = performanceStarts;
        }
        event.off_sale_moment = dates.moment(event.off_sale_date);
        event.on_sale_moment = dates.moment(event.on_sale_date);
        event.is_on_sale = event.off_sale_moment > now && event.on_sale_moment < now && event.availability_status !== 'Sold Out';

        events[timestamp] = events[timestamp] || [];
        events[timestamp].push(event);
    }

    function getWeeks(continuous, startFrom) {
        if (!startFrom) {
            startFrom = dates.moment(startFrom).startOf('month');
        }

        startFrom = startFrom.startOf('week');
        continuous = continuous || false;

        var
            start = now.clone().startOf('month').startOf('week'),
            months = [],
            totalMonths = lastEventDate.endOf('month').diff(firstEventDate, 'months'),
            count = 0,
            done = false;

        while (!done) {
            var
                month = buildMonth(start),
                weeks = [];

            month.forEach(function (week) {
                if (continuous) {
                    var day = week[0].day.clone();

                    if (!day.startOf('week').isBefore(startFrom)) {
                        weeks = weeks.concat(week);
                    }
                } else {
                    weeks = weeks.concat(week);
                }
            });

            if (continuous) {
                months = months.concat(weeks);
            } else {
                months.push(weeks);
            }

            start = start.clone();
            start.add(1, 'm');

            if (!continuous) {
                start.startOf('month').startOf('week');
            }

            done = count++ == totalMonths;
        }

        return months;
    };

    function buildMonth(date) {
        var
            weeks = [],
            done = false,
            monthIndex = date.month(),
            count = 0;

        while (!done) {
            weeks.push( buildWeek(date.clone()) );

            date.add(1, 'w');
            done = count++ > 2 && monthIndex !== date.month();
            monthIndex = date.month();
        }

        return weeks;
    };

    function buildWeek(date) {
        let days = [];

        for (let i = 0; i < 7; i++) {
            let
                timestamp = dates.moment([date.year(), date.month(), date.date()]).valueOf(),
                dayEvents = events[timestamp] || [];

            days.push({
                day: date,
                isInPast: date.isBefore(now, 'day'),
                isWeekInPast: date.isBefore(now, 'week') && !date.isSame(now, 'week'),
                isToday: date.isSame(now, 'day'),
                isThisYear: date.isSame(now, 'year'),
                isInFuture: date.isAfter(now, 'day'),
                isStartOfMonth: date.date() === 1,
                events: groupBy(dayEvents, item => item.prod_season_no),
            });

            date = date.clone();
            date.add(1, 'd');
        }

        return days;
    };

    return {
        getEvents: getEvents,
        getWeeks: getWeeks,
        weekDays: weekDays
    }
}];
